import { useState, useEffect, useRef } from "react";
import { useTranslation } from "next-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";

import Text from "ab-text";
import Input from "ab-input";
import Button from "ab-form-button";

import "./ab-form-experiencias.scss";

const SpaForm = ({ color, i18n }) => {
  const [loading, setLoading] = useState(false);
  const [host, setHost] = useState();
  const [timestamp, setTimestamp] = useState("");
  const formRef = useRef();
  const { t } = useTranslation("common", { i18n });

  useEffect(() => {
    setHost(window.location.origin);
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      nif: "",
      mobile: "",
      country: "",
      comentarios: "",
      gdpr: false,
      captcha: "",
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string().required(t("validationFirstName")),
      lastName: Yup.string().required(t("validationLastName")),
      email: Yup.string()
        .email(t("validationEmail"))
        .required(t("validationEmail")),
      nif: Yup.string().required(t("validationNIF")),
      mobile: Yup.string().required(t("validationMobile")),
      // comentarios: Yup.string().required(t("validationComentarios")),
      gdpr: Yup.boolean().isTrue(t("validationPrivacy")),
      captcha: Yup.string().required(t("validationCaptcha")),
    }),
    onSubmit: (values) => {
      setLoading(true);
      formRef.current.submit();
    },
  });

  const { values, setFieldValue, handleSubmit, errors } = formik;
  return (
    <div className={`ab-form ${color}`} name="form">
      <div className="left">
        <Text element="span" className="title">
          {""}
        </Text>
        <Text element="h2">{t("titleSesion")}</Text>
      </div>

      <div className="right">
        <form
          action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
          method="POST"
          ref={formRef}
          onSubmit={handleSubmit}
        >
          <input
            type="hidden"
            name="captcha_settings"
            value={JSON.stringify({
              keyname: "Abadia_Retuerta",
              fallback: "true",
              orgId: "00D1t000000Cn69",
              ts: timestamp || "",
            })}
          />
          <div
            className="g-recaptcha"
            data-sitekey={process.env.CAPTCHA_KEY}
          ></div>

          <Text element="span" className="title">
            {t("contact")}
          </Text>
          <div className="row">
            <Input
              placeholder={t("firstNameContact")}
              value={values.firstName}
              error={errors.firstName}
              onChange={(val) => setFieldValue("firstName", val)}
              id="m_first_name"
              maxLength="40"
              name="first_name"
            />
            <Input
              placeholder={t("lastNameContact")}
              value={values.lastName}
              error={errors.lastName}
              onChange={(val) => setFieldValue("lastName", val)}
              id="m_last_name"
              maxLength="80"
              name="last_name"
            />
          </div>
          <div className="row">
            <Input
              placeholder={t("emailContact")}
              value={values.email}
              error={errors.email}
              onChange={(val) => setFieldValue("email", val)}
              id="m_email"
              maxLength="80"
              name="email"
            />
          </div>

          <div className="row">
            <Input
              placeholder={t("nifOpasaporte")}
              value={values.cif}
              error={errors.cif}
              onChange={(val) => setFieldValue("cif", val)}
              id="m_00N1t00000LYoc6"
              maxLength="255"
              name="00N1t00000LYoc6"
            />

            <Input
              placeholder={t("mobile")}
              value={values.mobile}
              error={errors.mobile}
              onChange={(val) => setFieldValue("mobile", val)}
              id="m_mobile"
              maxLength="40"
              name="mobile"
            />
          </div>
          {/* <div className="row">
            <SelectCountry
              value={values.country}
              onChange={(e) => setFieldValue("country", e.target.value)}
              className="half"
              id="00N5E000002Yufg"
              name="00N5E000002Yufg"
            />
          </div> */}
          {/* AUTO SELECT IDIOMA */}
          <input
            type="hidden"
            id="00N1t00000LYoc2"
            name="00N1t00000LYoc2"
            value={i18n.language == "en" ? "en_US" : i18n.language}
          />
          <Text element="span" className="title">
            {t("comments")}
          </Text>
          <textarea
            name="description"
            placeholder=""
            value={values.comentarios}
            onChange={(e) => setFieldValue("comentarios", e.target.value)}
            className={`${errors.comentarios ? "error" : ""}`}
          />
          <Text element="span" className="error">
            {errors.comentarios}
          </Text>
          <Input
            type="checkbox"
            label={`<a class="gold" href=${host +
              t("linkPolicy")} target='_blank'>${t("privacy")}</a>`}
            value={values.gdpr}
            error={errors.gdpr}
            onChange={(val) => setFieldValue("gdpr", val)}
            id="m_00N1t00000LYobx"
            name="00N1t00000LYobx"
          />
          <input
            type="hidden"
            id="m_00N1t00000LYoc8"
            name="00N1t00000LYoc8"
            value="SpaSommelier"
          />
          <input type="hidden" name="oid" value="00D1t000000Cn69" />
          <input
            type="hidden"
            name="retURL"
            value={`${host}${t("/gracias")}`}
          />
          <input type="hidden" name="lead_source" value="Website" />
          <div style={{ maxWidth: 305, overflow: "auto" }}>
            {process.env.CAPTCHA_KEY && (
              <ReCAPTCHA
                sitekey={process.env.CAPTCHA_KEY}
                onChange={(val) => {
                  setFieldValue("captcha", val);
                  setTimestamp(new Date().getTime());
                }}
                hl={i18n.language?.toLowerCase()}
              />
            )}
          </div>
          {errors.captcha ? (
            <p>
              <Text element="span" className="error margin">
                {errors.captcha}
              </Text>
            </p>
          ) : null}

          {/* {process.env.STAGE == "dev" ? (
            <>
              <input type="hidden" name="debug" value="1" />
              <input
                type="hidden"
                name="debugEmail"
                value="javier.villoslada@habitant.es"
              />
            </>
          ) : null} */}
          <Button
            loading={loading}
            disabled={!values?.captcha || errors.captcha}
          >
            {t("send")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default SpaForm;
